import { getColors } from '@/core/constants/uiColors';
import { useThemeScheme } from '@/core/theme/ThemeProvider';

/**
 * Combined theme hook that provides both scheme and colors
 * This is the recommended hook for components that need theme awareness
 */
export function useTheme() {
    const scheme = useThemeScheme();
    const colors = getColors(scheme);

    return {
        scheme,
        colors,
        isDark: scheme === 'dark',
        isLight: scheme === 'light'
    } as const;
}

export type UseThemeReturn = ReturnType<typeof useTheme>;
